export const SignalLoader = {
  v: '5.9.6',
  fr: 60,
  ip: 0,
  op: 198,
  w: 1920,
  h: 1920,
  nm: 'Signal Diagonal Shape Animation - Orange to Blue Fill',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Animated Fill with Gradient',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [910, 910, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [25.11, 14.26, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              i: {
                x: [0.34, 0.34],
                y: [1, 1],
              },
              o: {
                x: [0.64, 0.64],
                y: [0, 0],
              },
              t: 150,
              s: [220, 220, 100],
            },
            {
              i: {
                x: [0.34, 0.34],
                y: [1, 1],
              },
              o: {
                x: [0.64, 0.64],
                y: [0, 0],
              },
              t: 156,
              s: [238, 238, 100],
            },
            {
              t: 168,
              s: [220, 220, 100],
            },
          ],
          ix: 6,
        },
      },
      ao: 0,
      ef: [
        {
          ty: 25,
          nm: 'Drop Shadow',
          np: 8,
          mn: 'ADBE Drop Shadow',
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 2,
              nm: 'Shadow Color',
              mn: 'ADBE Drop Shadow-0001',
              ix: 1,
              v: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.34],
                      y: [1],
                    },
                    o: {
                      x: [0.64],
                      y: [0],
                    },
                    t: 150,
                    s: [1, 0.576, 0.2, 0.6],
                  },
                  {
                    t: 152,
                    s: [0.2, 0.4, 0.9, 0.6],
                  },
                ],
                ix: 1,
              },
            },
            {
              ty: 0,
              nm: 'Opacity',
              mn: 'ADBE Drop Shadow-0002',
              ix: 2,
              v: {
                a: 0,
                k: 30,
                ix: 2,
              },
            },
            {
              ty: 0,
              nm: 'Direction',
              mn: 'ADBE Drop Shadow-0003',
              ix: 3,
              v: {
                a: 0,
                k: 180,
                ix: 3,
              },
            },
            {
              ty: 0,
              nm: 'Distance',
              mn: 'ADBE Drop Shadow-0004',
              ix: 4,
              v: {
                a: 0,
                k: 2,
                ix: 4,
              },
            },
            {
              ty: 0,
              nm: 'Softness',
              mn: 'ADBE Drop Shadow-0005',
              ix: 5,
              v: {
                a: 0,
                k: 16,
                ix: 5,
              },
            },
          ],
        },
      ],
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [28.3038, 5.08863],
                    [24.7347, 11.3802],
                    [23.716, 12.8221],
                    [21.3968, 14.135],
                    [20.0891, 14.2498],
                    [8.21143, 14.2498],
                    [0.314667, 28.1816],
                    [12.1851, 28.1816],
                    [15.9926, 27.7942],
                    [21.9098, 23.4253],
                    [25.4789, 17.1337],
                    [26.4976, 15.6918],
                    [28.824, 14.3717],
                    [30.1244, 14.2569],
                    [42.0021, 14.2569],
                    [49.8989, 0.332275],
                    [38.0356, 0.332275],
                    [34.2281, 0.71967],
                    [28.3038, 5.08863],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'gf',
              o: {
                a: 0,
                k: 100,
                ix: 10,
              },
              r: 1,
              bm: 0,
              g: {
                p: 4,
                k: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.34,
                        y: 1,
                      },
                      o: {
                        x: 0.64,
                        y: 0,
                      },
                      t: 150,
                      s: [
                        0, 0.91, 0.478, 0.122, 0.3, 1, 0.576, 0.2, 0.6, 1, 0.702, 0.4, 1, 1, 0.8,
                        0.502,
                      ],
                    },
                    {
                      t: 152,
                      s: [0, 0.2, 0.4, 0.9, 0.3, 0.3, 0.6, 1, 0.6, 0.5, 0.75, 1, 1, 0.7, 0.85, 1],
                    },
                  ],
                  ix: 9,
                },
              },
              s: {
                a: 0,
                k: [0, 14.5],
                ix: 5,
              },
              e: {
                a: 0,
                k: [50, 14.5],
                ix: 6,
              },
              t: 1,
              nm: 'Gradient Fill 1',
              mn: 'ADBE Vector Graphic - G-Fill',
              hd: false,
            },
            {
              ty: 'tm',
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.42],
                      y: [1],
                    },
                    o: {
                      x: [0.58],
                      y: [0],
                    },
                    t: 0,
                    s: [100],
                  },
                  {
                    t: 150,
                    s: [0],
                  },
                ],
                ix: 1,
              },
              e: {
                a: 0,
                k: 100,
                ix: 2,
              },
              o: {
                a: 0,
                k: 0,
                ix: 3,
              },
              m: 1,
              ix: 3,
              nm: 'Trim Paths 1',
              mn: 'ADBE Vector Filter - Trim',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [220, 220],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Fill Shape',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 198,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Glow Pulse',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.42],
                y: [1],
              },
              o: {
                x: [0.58],
                y: [0],
              },
              t: 150,
              s: [60],
            },
            {
              t: 198,
              s: [0],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [910, 910, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [25.11, 14.26, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              i: {
                x: [0.42, 0.42],
                y: [1, 1],
              },
              o: {
                x: [0.58, 0.58],
                y: [0, 0],
              },
              t: 150,
              s: [220, 220, 100],
            },
            {
              t: 198,
              s: [308, 308, 100],
            },
          ],
          ix: 6,
        },
      },
      ao: 0,
      ef: [
        {
          ty: 29,
          nm: 'Gaussian Blur',
          np: 4,
          mn: 'ADBE Gaussian Blur 2',
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: 'Blurriness',
              mn: 'ADBE Gaussian Blur 2-0001',
              ix: 1,
              v: {
                a: 0,
                k: 8,
                ix: 1,
              },
            },
          ],
        },
      ],
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [28.3038, 5.08863],
                    [24.7347, 11.3802],
                    [23.716, 12.8221],
                    [21.3968, 14.135],
                    [20.0891, 14.2498],
                    [8.21143, 14.2498],
                    [0.314667, 28.1816],
                    [12.1851, 28.1816],
                    [15.9926, 27.7942],
                    [21.9098, 23.4253],
                    [25.4789, 17.1337],
                    [26.4976, 15.6918],
                    [28.824, 14.3717],
                    [30.1244, 14.2569],
                    [42.0021, 14.2569],
                    [49.8989, 0.332275],
                    [38.0356, 0.332275],
                    [34.2281, 0.71967],
                    [28.3038, 5.08863],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'gf',
              o: {
                a: 0,
                k: 100,
                ix: 10,
              },
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [0, 0.2, 0.4, 1, 0.5, 0.302, 0.6, 1, 1, 0.702, 0.851, 0.8],
                  ix: 9,
                },
              },
              s: {
                a: 0,
                k: [25, 14],
                ix: 5,
              },
              e: {
                a: 0,
                k: [40, 14],
                ix: 6,
              },
              t: 2,
              nm: 'Gradient Fill 1',
              mn: 'ADBE Vector Graphic - G-Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [0, 0],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [220, 220],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Glow',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 150,
      op: 198,
      st: 0,
      bm: 0,
    },
  ],
  markers: [
    {
      tm: 0,
      cm: 'Fill Start - Orange Gradient',
      dr: 0,
    },
    {
      tm: 150,
      cm: 'Fill Complete - Color Transition to Blue',
      dr: 0,
    },
    {
      tm: 152,
      cm: 'Blue Gradient Complete - Bounce Effect',
      dr: 0,
    },
    {
      tm: 168,
      cm: 'Bounce Complete',
      dr: 0,
    },
    {
      tm: 198,
      cm: 'Animation End',
      dr: 0,
    },
  ],
  meta: {
    g: 'Signal Animation Export',
    a: 'Signal Diagonal Shape Animation',
    k: 'signal, diagonal, fill, orange, blue, gradient, loading, progress, animation, lottie',
    d: 'Diagonal signal shape animation with orange gradient fill that transitions to blue on completion, includes bounce effect and glow pulse. Perfect for loading indicators and progress animations.',
    tc: '#FF9332',
  },
};
